function extractClientAndDeliverableFromUrl(pathname, parentPath) {
	const client = pathname?.split(parentPath)[1]?.split("/")[0];
	const deliverables = pathname?.split(parentPath)[1]?.split("/")[1];

	return { client, deliverables };
}

export { extractClientAndDeliverableFromUrl };
